import React from "react";
import { Button } from "../ui/button";
import { EmptyStateLogoOption2 } from "./logos/empty-state-logo-option2";

export const NoLoansWrapper = ({
  onCheckRatesClick = () => {},
  onApplyLoanClick = () => {},
}) => {
  return (
    <div className='flex flex-1 items-center justify-center bg-primary-7'>
      <div className='flex flex-col items-center gap-8'>
        <EmptyStateLogoOption2 />
        <div>
          <p className='font-semibold text-3xl text-neutral-10 mb-4 mx-auto text-center'>
            Start Your First Loan Application
          </p>
          <p className='font-light text-center text-base text-neutral-8 max-w-md mx-auto'>
            Once you start applying, all your loan applications will be listed
            here. Let’s get your first one going
          </p>
        </div>
        <div className="flex items-center gap-3">
            <Button
                variant="primaryGhost"
                size="lg"
                className="rounded-2xl px-8 py-6"
                onClick={onCheckRatesClick}
            >
                Check Rates
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="rounded-2xl px-8 py-6"
              onClick={onApplyLoanClick}
            >
              Apply Now
            </Button>
        </div>
      </div>
    </div>
  );
};